angular.module('SpidApp')

.controller('CartController',
		['$scope', 'Cart', 'Sale', 'CartService', 'Toaster', 'Drawer', 'focus', 'StockManager', 'ConfigService', 'ReceiptPDFBuilder', 'ReceiptPrinter',
function ($scope,   Cart,   Sale,   CartService,   Toaster,   Drawer,   focus,   StockManager,   ConfigService,   ReceiptPDFBuilder,   ReceiptPrinter) {
	
	$scope.cart = Cart.getInstance()
	$scope.setPrintStatusPending = function (sale) {
		sale.setPrintStatus(Sale.PRINT_STATUS_PENDING)
	}

	var saveCart = function () {
		return ConfigService.all().then(function (memo) {
			return CartService.save($scope.currentVacation, $scope.cart, false, $scope.user.username, memo.lastSyncIsoDate, {
				currency_rate : $scope.agency.currency.rate
			})
		})
	}
	
	$scope.setPrintStatusRefunded = function (index, sale) {
		sale.setPrintStatus(Sale.PRINT_STATUS_REFUNDED)
		$scope.cart.addSaleRefund(index, sale)
		
		saveCart()
	}

	$scope.setPrintStatusSuccess = function (sale) {
		sale.setPrintStatus(Sale.PRINT_STATUS_SUCCESS)
	}

	$scope.setPrintStatusFailure = function (index, sale) {
		sale.setPrintStatus(Sale.PRINT_STATUS_FAILURE)
		$scope.cart.addSaleRefund(index, sale)
		
		saveCart()
	}

	$scope.saleQuantityChange = function (index, sale, onBlurEvent) {
		if (onBlurEvent && sale.quantity === undefined) {
			sale.quantity = 1;
		}
		
		if (onBlurEvent && (sale.quantity === null || sale.quantity === undefined || sale.quantity <= 0 || sale.quantity.length === 0)) {
			$scope.cart.removeSale(index)
			return
		}

		$scope.cart.updateTotal();
	}
	
	$scope.incrementQuantity = function (sale) {
		if ($scope.cartIsValidated) {
			return
		}
		
		$scope.cart.incrementSaleQuantity(sale)
	}

	$scope.decrementQuantity = function (index, sale) {
		if ($scope.cartIsValidated) {
			return
		}
		
		if (sale.quantity === null || sale.quantity === undefined || sale.quantity <= 0) {
			$scope.cart.removeSale(index)
		}
		
		if (sale.quantity === 1) {
			$scope.cart.removeSale(index)
		} else {
			$scope.cart.decrementSaleQuantity(sale)
		}
	}
	
	$scope.validateCart = function () {
		
		if(!$scope.cart.isValidable()) {
			return
		}
		
		$scope.cart.setValidated()
		
		return ConfigService.all().then(function (memo) {
			return CartService.save($scope.currentVacation, $scope.cart, false, $scope.user.username, memo.lastSyncIsoDate, {
				currency_rate : $scope.agency.currency.rate
			})
		}).then(function(data){
			if(data[0] !== null){
				$scope.cart.transaction_id = data[0].id;
			}

			for (var i=1; i < data.length;i++){
				if(data[i] !== null){
                    $scope.cart.objects[i-1].key = data[i].id;
				}

			}
		}).finally(function () {
			focus('payment-received-input')
		});
	}
	
	$scope.finishTransaction = function (){
		if($scope.cart.balance < 0){
			Toaster.danger('Paiement insuffisant');
      		return;
		}

		if(parseFloat($scope.cart.totalPrice).toFixed(2) !== parseFloat($scope.cart.recu).toFixed(2)){
			Toaster.danger('Le total du paiement par carte CB doit être égale au total à payer en Euro : ' + $scope.cart.totalPrice );
			return;
		}
		
		$scope.disableSaveTransactionButton = true
		
		return ConfigService.all().then(function (memo) {
			return CartService.save($scope.currentVacation, $scope.cart, true, $scope.user.username, memo.lastSyncIsoDate, {
				currency_rate : $scope.agency.currency.rate
			})
		}).then(function () {
			Drawer.open();
			
			var arrayOfSales = Sale.getSaleProductsOnly($scope.cart.objects);
			StockManager.manageOutOfStock(arrayOfSales, $scope.agency.id);
			
		}).then(function(){
			var localCurrencySymbol = $scope.agency.currency.symbol;

			var pdf = ReceiptPDFBuilder.generate(
				  $scope.cart
				, localCurrencySymbol
			);

			return ReceiptPrinter.print(pdf).then(function () {
				Toaster.show('Ticket envoyé pour impression')
			}).catch(function () {
				Toaster.danger('Impossible d\'imprimer le ticket')
			})
		}).finally(function () {
			Toaster.show("La vente a été sauvegardée");
			$scope.cart.setUnvalidated();
			$scope.cart.flush();
			
			$scope.disableSaveTransactionButton = false
		})
	}
	
	$scope.cancelTransaction = function () {
		if ($scope.cart.isEmpty()) {
			return
		}

		Toaster.danger('La vente a été annulée')
		$scope.cart.flush()
	}

}])